<template>
    <section class="coupon-inner">
        <ul class="list">
            <li class="quan-no" v-for="(coupon, index) in displayCouponList" :key="index">
                <div :class="{'quan-inform': true, 'received': coupon.isReceived}">
                    <div class="left-inform" @click="expandRule(index)">
                        <!-- <div> -->
                        <div class="price-ctn" v-if="coupon.translatedFaceObj">
                            <span class="price-ctn" v-if="coupon.translatedFaceObj.unit =='元' ">¥</span>
                            <span v-if="coupon.translatedFaceObj.value" :class="/\d/g.test(coupon.translatedFaceObj.value)?'big-price':'middle-text'">{{coupon.translatedFaceObj.value}}</span>
                            <span v-if="coupon.translatedFaceObj.unit &&  coupon.translatedFaceObj.unit !=='元'">{{coupon.translatedFaceObj.unit}}</span>
                            <span class="coupon-type">{{coupon.typeName}}</span>
                        </div>
                            <!-- <div v-else>
                                <div class="price-ctn" v-if="coupon.translatedFaceValue && /\d/g.test(coupon.translatedFaceValue)">
                                    ¥<span class="big-price">{{parseInt(coupon.translatedFaceValue, 10)}}</span><span class="coupon-type">{{coupon.typeName}}</span>
                                </div>
                                <div class="price-ctn" v-else-if="coupon.translatedFaceValue">
                                    <span class="middle-text">{{coupon.translatedFaceValue}}</span><span class="coupon-type">{{coupon.typeName}}</span>
                                </div>
                            </div> -->
                        <!-- </div> -->
                        <div class="coupon-limit" style="width: 100%;" v-if="coupon.translatedRule && coupon.translatedRule.length">{{coupon.translatedRule[0]}}</div>
                        <div class="quan-time">有效期：<span>{{coupon.beginDate}}</span> 至 <span>{{coupon.endDate}}</span></div>
                        <div class="quan-theme">活动主题：{{coupon.retailPsName || ''}}<em :class="expandIndex === index ? 'expanded' : 'fold'"><i></i></em></div>
                    </div>
                    <div class="right-inform">
                        <a href="javascript:void(0);" class="main-button" @click="receiveCoupons(coupon, index)" v-if="!coupon.isReceived">立即领取</a>
                        <a href="javascript:;" @click="goPackagePage" v-if="coupon.isReceived" class="main-button">去使用</a>
                        <a href="javascript:;" @click="goProductListPage" v-if="coupon.isReceived" class="look-more">查看可用</a>
                    </div>
                </div>
                <div class="quan-rules" v-show="expandIndex === index">
                    <div class="quan-rule" v-if="Array.isArray(coupon.planDateList) && coupon.planDateList.length">
                        <h3 class="quan-rule-title">适用团期</h3>
                        <ul class="plan-date-list">
                            <li v-for="item in coupon.planDateList" :key="item.month" v-if="item.dates">
                                <span>{{item.month}}：</span>{{item.dates}}
                            </li>
                        </ul>
                    </div>
                    <div class="quan-rule" v-if="coupon.webHtml">
                        <h3 class="quan-rule-title">活动说明</h3>
                        <p v-if="coupon.webHtml" v-html="coupon.webHtml.replace(/\n/g, '<br>')"></p>
                    </div>
                </div>
            </li>
        </ul>
        <div class="coupon-tips" v-if="couponMsg"><p>{{couponMsg}}</p></div>
    </section>
</template>

<script>
import { receiveCouponsP } from 'create-api';
import { pageTrack } from '@/business/analy';
const LOGIN_URL = '/u/login';

export default {
    name: 'CouponInner',
    props: {
        couponList: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data: function() {
        let displayCouponList = this.couponList.map(e => Object.assign({isReceived: false}, e));
        return {
            expandIndex: -1,
            couponMsg: '',
            currentPromotionId: 0,
            displayCouponList
        }
    },
    computed: {
        baseInfo () {
            return this.$store.state.detail.baseInfo
        },
        status () {
            return this.baseInfo.status
        }
    },
    methods: {
        expandRule (index) {
            if (index === this.expandIndex) {
                this.expandIndex = -1;
            } else {
                this.expandIndex = index;
            }
        },
        hideCouponTip () {
            setTimeout(() => {
                this.couponMsg = '';
            }, 3000);
        },
        receiveCoupons (coupon, index) {
            receiveCouponsP({
                'psId': coupon.retailPsId
            })
            .then(res => {
                if (res && res.success && res.data) {
                    coupon.isReceived = true;
                     this.currentPromotionId = coupon.retailPsId;
                } else if (res && res.needLogin) {
                    setTimeout(function() {
                       location.href = LOGIN_URL;
                    }, 10);
                } else {
                    this.couponMsg = res.message || '领取失败';
                }
                this.hideCouponTip();
            })
            .catch((err) => {
                this.couponMsg = '领取失败';
                this.hideCouponTip();
            });

        },
        goProductListPage () {
            location.href = this.getAppLink('/promotion/' + this.currentPromotionId + '/products');
        },
        goPackagePage(){
            if (this.baseInfo.classBrandParentId === 56) {
                this.showPackagePopup();
            } else {
                this.$router.replace(this.getAppLink('/item/' + this.$route.params.id + '/package'));
            }
        },
        showPackagePopup () {
            if (this.status === 1) {
                this.$emit('openPackagePopup');
                this.$emit('closeCouponPopup');
            }
        },
    }
}
</script>

<style lang="scss">
.coupon-inner {
    .list {
        box-sizing: border-box;
        width: 100%;
        padding: 10px 10px 0;
        > li {
            position: relative;
            margin-bottom: 13px;
            border-radius: 9px;
            overflow: hidden;
            background: #ffeee8;
            &:before {
                content: "";
                position: absolute;
                right: 87px;
                top: 0;
                width: 10px;
                height: 10px;
                border-radius: 100%;
                background: #fff;
                z-index: 1;
                transform: translateY(-50%);
            }
            &:after {
                content: "";
                position: absolute;
                right: 87px;
                bottom: 0;
                width: 10px;
                height: 10px;
                border-radius: 100%;
                background: #fff;
                z-index: 1;
                transform: translateY(50%);
            }
        }
        .quan-inform {
            position: relative;
            .left-inform {
                position: relative;
                color: #ff7733;
                padding: 10px 0 10px 15px;
                margin-right: 80px;
                line-height: 16px;
                font-size: 12px;
            }
            .price-ctn {
                font-size: 12px;
                line-height: 30px;
                .big-price {
                    margin-left: 2px;
                    font-size: 30px;
                }
                .middle-text {
                    font-size: 24px;
                    font-weight: 500;
                }
                .coupon-type {
                    margin-left: 10px;
                }
            }
            .coupon-limit, .quan-time, .quan-theme {
                font-weight: 300;
            }
            .quan-theme em {
                position: relative;
                display: inline-block;
                width: 12px;
                height: 12px;
                border-radius: 100%;
                background: rgba(255,119,51,0.80);
                vertical-align: -2px;
                margin-left: 2px;
                i {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 4px;
                    height: 4px;
                    transition: all 0.5s;
                    -webkit-transition: all 0.5s;
                    transform: translateX(-3px) translateY(-3px) rotate(45deg);
                    transform-origin: 60% 60%;
                    border-right: 1px solid #fff;
                    border-bottom: 1px solid #fff;

                }
                &.expanded {
                    i {
                        transform: translateX(-3px) translateY(-3px) rotate(-135deg);
                    }
                }
            }
            .right-inform {
                position: absolute;
                right: 0;
                top: 0;
                width: 90px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                border-left: 2px dotted rgba(222, 159, 128, 0.15);
                .main-button {
                    display: block;
                    border:1px solid #ff7733;
                    border-radius:14px;
                    width: 64px;
                    height: 26px;
                    line-height: 26px;
                    text-align: center;
                    font-size: 12px;
                    color: #ff7733;;
                }
                .look-more {
                    display: block;
                    font-size: 12px;
                    line-height: 18px;
                    margin-top: 8px;
                    color: #999;
                }
            }
            &.received:before {
                content: "已领";
                position: absolute;
                right: 77px;
                bottom: -24px;
                width:51px;
                height:51px;
                line-height: 38px;
                font-size: 17px;
                text-align: center;
                color :#ffdbd1;
                border:4px solid #ffdbd1;
                border-radius: 100%;
                transform: rotate(-15deg);
            }
        }
        .quan-rules {
            line-height: 20px;
            padding: 8px 15px;
            font-size: 12px;
            color: #ff5500;
            transition: 0.3s;
            overflow: hidden;
            font-weight: 300;
            background: #fbe6df;
            .quan-rule {
              padding-top: 8px;
              &:first-child {
                padding-top: 0;
              }
              .quan-rule-title {
                  font-weight: 500;
              }
            }
        }
    }
    .masker-coupon {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
        z-index: 100;
        touch-action: manipulation;
    }
    .coupon-tips {
        position: fixed;
        z-index: 1;
        top: 50%;
        left: 50%;
        p {
            position: absolute;
            top: 0;
            left: 0;
            width: 140px;
            padding: 12px;
            border-radius: 4px;
            font-size: 14px;
            line-height: 26px;
            color: #fff;
            text-align: center;
            background-color: rgba(0,0,0,0.7);
            transform: translateX(-50%) translateY(-50%);
        }
    }
}

 </style>



// WEBPACK FOOTER //
// CouponInner.vue